// Environment Variable Validation
// This file checks that all required environment variables are set
// If any are missing, it shows a clear error and prevents the app from starting

const REQUIRED_ENV_VARS = {
  // Firebase Configuration
  REACT_APP_FIREBASE_API_KEY: 'Firebase API Key',
  REACT_APP_FIREBASE_AUTH_DOMAIN: 'Firebase Auth Domain',
  REACT_APP_FIREBASE_PROJECT_ID: 'Firebase Project ID',
  REACT_APP_FIREBASE_STORAGE_BUCKET: 'Firebase Storage Bucket',
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: 'Firebase Messaging Sender ID',
  REACT_APP_FIREBASE_APP_ID: 'Firebase App ID',
  REACT_APP_FIREBASE_MEASUREMENT_ID: 'Firebase Measurement ID',

  // WalletConnect Configuration
  REACT_APP_WALLETCONNECT_PROJECT_ID: 'WalletConnect Project ID',

  // Etherscan Configuration
  // REACT_APP_ETHERSCAN_API_KEY: 'Etherscan API Key'
};

function validateEnvironmentVariables() {
  const missingVars = [];

  // Check each required variable
  Object.entries(REQUIRED_ENV_VARS).forEach(([envVar, description]) => {
    if (!process.env[envVar]) {
      missingVars.push({ envVar, description });
    }
  });

  // If any are missing, show error and exit
  if (missingVars.length > 0) {
    console.error('\n❌ ERROR: Missing required environment variables!\n');
    console.error('The following environment variables are required but not set:\n');

    missingVars.forEach(({ envVar, description }) => {
      console.error(`  ❌ ${envVar}`);
      console.error(`     (${description})\n`);
    });

    console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.error('\n📋 To fix this:\n');
    console.error('1. Make sure you have a .env file in the root directory');
    console.error('2. Copy .env.example to .env if you haven\'t already:');
    console.error('   cp .env.example .env\n');
    console.error('3. Fill in all required values in your .env file');
    console.error('4. Restart the development server: npm start\n');
    console.error('📖 See DEPLOYMENT.md for detailed setup instructions');
    console.error('\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');

    // Exit the process
    process.exit(1);
  }

}

// Run validation immediately when this module is imported
validateEnvironmentVariables();

export default validateEnvironmentVariables;
